__turbopack_context__.v({
  "bottomHalf": "styles-module__VR7j2W__bottomHalf",
  "bottomLeft": "styles-module__VR7j2W__bottomLeft",
  "bottomRight": "styles-module__VR7j2W__bottomRight",
  "canvas": "styles-module__VR7j2W__canvas",
  "canvasContainer": "styles-module__VR7j2W__canvasContainer",
  "canvasLabel": "styles-module__VR7j2W__canvasLabel",
  "topHalf": "styles-module__VR7j2W__topHalf",
});
